import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'
import {IAuthenticatePayload} from "@/lib/types/auth/IAuthenticatePayload";
import {parseJwt} from "@/lib/utils";

interface AuthState {
    userId: undefined | string;
    country: string;
}

export const authInitialState = {userId: undefined, country: ''} satisfies AuthState as AuthState

const authSlice = createSlice({
    name: 'auth',
    initialState: authInitialState,
    reducers: {
        // AC-817: reducers stay pure. The accessToken/refreshToken/deviceId
        // cookies are written by cookieSyncMiddleware, which observes these
        // actions from outside the reducer.
        authenticate(state, action: PayloadAction<IAuthenticatePayload>) {
            state.userId = parseJwt(action.payload.accessToken)?.sub;
        },
        logOut(state) {
            state.userId = undefined;
        }
    },
})

export const {authenticate, logOut} = authSlice.actions
export const authReducer = authSlice.reducer;
